// extracted by mini-css-extract-plugin
export default {"bottomblock":"HomePage_bottomblock__a6EPr","wave":"HomePage_wave__xidLT"};